const commonConfig = {
  confirm_btn: '確認',
  cancel_btn: '取消',
  not_data: '暫無數據',
  updata_data_suc: '數據更新成功',
  updata_data_fail: '數據更新失敗',
  online: '在線',
  off_line: '離線',
  waiting: '連線中...'
};

export default commonConfig;
